import { ReactNode } from 'react';

import { i18, trb } from '../../Utilities';
import { PayeeVerificationStatus } from '../PayeeVerificationStatus/PayeeVerificationStatus.tsx';
import { ContentNoData } from '../ContentNoData';
import { EnumVerifyPayeeMatch } from 'src/api';
import { getVopType } from 'src/Utilities/vop';

interface IProps {
  title: string | ReactNode;
  data: {
    ID: string;
    Amount: {
      Text: string;
    }[];
    SenderName: string;
    SenderAccount: string;
    ReceiverName: string;
    ReceiverAccount: string;
    VopCloseMatchName: string;
    PaymentPurpose: string;
    UniqPayCode: string;
    VopResponseType: EnumVerifyPayeeMatch;
    VopDetails?: string;
  }[];
}

export const TableUnsignedPaymentFiles = ({ title, data }: IProps) => {
  if (!data?.length) {
    return (
      <>
        <h3 className="eb_content_subtitle">{title}</h3>
        <ContentNoData id="TableUnsignedPaymentFilesEmpty" />
      </>
    );
  }

  return (
    <>
      <h3 className="eb_content_subtitle">{title}</h3>
      <div className="eb_table mb-3 w-100 eb_table_wrapper_bottom_lined">
        <div className="row eb_table_head d-none d-lg-flex">
          <div className="col-md-3">{trb(i18.Labels.Payer)}</div>
          <div className="col-md-3 ">{trb(i18.Labels.PayeePaymentUploading)}</div>
          <div className="col-md-4 ">{trb(i18.Labels.DestinationsCode)}</div>
          <div className="col-md-2 text-right">{trb(i18.Labels.Amount)}</div>
        </div>
        {data?.map((item) => {
          const VopResponseType = getVopType(item.VopResponseType, item.VopDetails);

          return (
            <div
              className="row eb_table_row"
              key={item.ID}
            >
              <div className="col-12 col-sm-6 col-md-6 col-lg-3">
                <div>{item.SenderName}</div>
                <div>{item.SenderAccount}</div>
              </div>
              <div className="col-12 col-sm-6 col-md-6 col-lg-3">
                <div>
                  {VopResponseType ? (
                    <PayeeVerificationStatus
                      VopResponseType={VopResponseType}
                      ReceiverName={item.ReceiverName}
                      MatchedName={item.VopCloseMatchName}
                    />
                  ) : (
                    item.ReceiverName
                  )}
                </div>
                <div>{item.ReceiverAccount}</div>
              </div>
              <div className="col-12 col-sm-6 col-md-6 col-lg-4">
                <div>{item.PaymentPurpose}</div>
                <div>{item.UniqPayCode}</div>
              </div>
              <div className="col-12 col-sm-6 col-md-6 col-lg-2 text-lg-right">
                <div>{item.Amount?.[0]?.Text}</div>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};
